import { render } from "./ViewMediatheque.vue?vue&type=template&id=f6f7196e&ts=true"
import script from "./ViewMediatheque.vue?vue&type=script&lang=ts"
export * from "./ViewMediatheque.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__